import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import qs from "qs";

import TemplateInfo from "../components/public/TemplateInfo";
import AssetInfo from "../components/public/AssetInfo";
import { fetchTemplateDetails } from "../store/actions/templateActions";
import { getAssetDetails } from "../store/actions/resourcesActions";
import VideoPlayer from "../components/ui/VideoPlayer ";
import { TEMPLATE_GROUP_VIDEO } from "../constants/pageSizeModal";

/**
 * A Custom react hook for fetch service which use from DocHipo Website
 * - Template: Use template from website
 * - Asset: Use asset design from website
 */
const useWebsiteService = () => {
  const dispatch = useDispatch();

  const [webComponent, setWebComponent] = useState();
  const [isWebsiteView, setIsWebsiteView] = useState();
  const [viewType, setViewType] = useState();

  const templateInfo = useSelector(state => state.template?.templateDetails);
  const assetInfo = useSelector(state => state.resources?.assetInfo);

  useEffect(() => {
    if (templateInfo?.data?.thumb && viewType === "TEMPLATE") {
      if (templateInfo?.data?.group === TEMPLATE_GROUP_VIDEO)
        setWebComponent(<VideoPlayer templateInfo={templateInfo?.data} />);
      else
        setWebComponent(<TemplateInfo templateInfo={templateInfo?.data} />);
    }
    if (assetInfo?.thumb && viewType === "ASSET") {
      setWebComponent(<AssetInfo assetInfo={assetInfo} />);
    }
  }, [templateInfo, assetInfo]);

  useEffect(() => {
    if (qs.parse(location?.search?.substring(1))?.target) {
      // check avialable target endpoint
      let targetPageEndpoint = window.sessionStorage.getItem(qs.parse(location.search.substring(1)).target);
      if (targetPageEndpoint?.includes("/templates/") && targetPageEndpoint?.includes("/preview")) {
        dispatch(fetchTemplateDetails(targetPageEndpoint.split("/")[2]));
        setIsWebsiteView(true);
        setViewType("TEMPLATE");
      } else if (targetPageEndpoint?.includes("/templates?uasset=")) {
        // Use a regular expression to extract the value of 'uasset'
        const match = targetPageEndpoint.match(/[?&]uasset=([^&]+)/);

        // If a match is found, extract the value
        const uassetValue = match && match[1];
        dispatch(getAssetDetails(uassetValue));
        setIsWebsiteView(true);
        setViewType("ASSET");
      } else {
        setIsWebsiteView(false);
      }
    } else {
      setIsWebsiteView(false);
    }

    return () => {
      setWebComponent();
    };
  }, []);

  return { isWebsiteView, webComponent };
};

export default useWebsiteService;
